import React, { useState, useEffect } from 'react';
import styles from '../phiosophy.module.css';

const EditPublic403bModal = ({ isOpen, onClose, data, onSave, loading }) => {
  const [formData, setFormData] = useState({
    ein: '',
    employer_name: '',
    url: '',
    plan_rating: 0,
    fund_options_sub_header: '',
    fund_options_description: '',
    fund_options_star_rating: 0,
    average_expense_ratio_sub_header: '',
    average_expense_ratio_description: '',
    average_expense_ratio_star_rating: 0,
  });

  useEffect(() => {
    if (data) {
      setFormData({
        ein: data.ein || '',
        employer_name: data.employer_name || '',
        url: data.url || '',
        plan_rating: data.plan_rating || 0,
        fund_options_sub_header: data.fund_options_sub_header || '',
        fund_options_description: data.fund_options_description || '',
        fund_options_star_rating: data.fund_options_star_rating || 0,
        average_expense_ratio_sub_header:
          data.average_expense_ratio_sub_header || '',
        average_expense_ratio_description:
          data.average_expense_ratio_description || '',
        average_expense_ratio_star_rating:
          data.average_expense_ratio_star_rating || 0,
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === 'plan_rating'
          ? parseFloat(value) || 0
          : name.includes('rating')
            ? parseInt(value, 10) || 0
            : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(data.id, formData);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Edit 403b Data</h2>
          <button className={styles.closeButton} onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>EIN</label>
            <input
              type="text"
              name="ein"
              value={formData.ein}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Plan Name</label>
            <input
              type="text"
              name="employer_name"
              value={formData.employer_name}
              onChange={handleChange}
              className={styles.formInput}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>URL Slug</label>
            <input
              type="text"
              name="url"
              value={formData.url}
              onChange={handleChange}
              className={styles.formInput}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Plan Rating (0-5)</label>
            <input
              type="number"
              name="plan_rating"
              min="0"
              max="5"
              value={formData.plan_rating}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Fund Options Sub-Header</label>
            <input
              type="text"
              name="fund_options_sub_header"
              value={formData.fund_options_sub_header}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Fund Options Description</label>
            <textarea
              name="fund_options_description"
              value={formData.fund_options_description}
              onChange={handleChange}
              className={styles.formTextarea}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              Fund Options Star Rating (0-5)
            </label>
            <input
              type="number"
              name="fund_options_star_rating"
              min="0"
              max="5"
              value={formData.fund_options_star_rating}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              Average Expense Ratio Sub-Header
            </label>
            <input
              type="text"
              name="average_expense_ratio_sub_header"
              value={formData.average_expense_ratio_sub_header}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              Average Expense Ratio Description
            </label>
            <textarea
              name="average_expense_ratio_description"
              value={formData.average_expense_ratio_description}
              onChange={handleChange}
              className={styles.formTextarea}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              Average Expense Ratio Star Rating (0-5)
            </label>
            <input
              type="number"
              name="average_expense_ratio_star_rating"
              min="0"
              max="5"
              value={formData.average_expense_ratio_star_rating}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.modalFooter}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={styles.saveButton}
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPublic403bModal;
